import { DeliverySlot } from '@delivery/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { DeliveryState, StateWithDelivery } from '../delivery-state';
import { getDeliveryState } from './state.selectors';

export const getDeliverySlotsState: MemoizedSelector<
  StateWithDelivery,
  StateUtils.LoaderState<DeliverySlot[]>
> = createSelector(getDeliveryState, (state: DeliveryState) => state.deliverySlots);

export const getDeliverySlotsValue: MemoizedSelector<StateWithDelivery, DeliverySlot[]> = createSelector(
  getDeliverySlotsState,
  (state: StateUtils.LoaderState<DeliverySlot[]>) => StateUtils.loaderValueSelector(state),
);

export const getDeliverySlotsLoading: MemoizedSelector<StateWithDelivery, boolean> = createSelector(
  getDeliverySlotsState,
  (state: StateUtils.LoaderState<DeliverySlot[]>) => StateUtils.loaderLoadingSelector(state),
);
